import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';
export function Header() {
  const {
    itemCount
  } = useCart();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#0f0f0f]/80 backdrop-blur-xl border-b border-gray-900" data-id="element-97">
      <div className="container mx-auto px-4" data-id="element-98">
        <div className="flex items-center justify-between h-20" data-id="element-99">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-id="element-100">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#FF6B35] to-[#FFA500] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-101">
              <span className="text-white font-black text-xl" data-id="element-102">P</span>
            </div>
            <div className="hidden sm:block" data-id="element-103">
              <div className="text-white font-black text-lg leading-none" data-id="element-104">
                PRECISION PRO
              </div>
              <div className="text-gray-500 text-xs font-medium" data-id="element-105">
                INDUSTRIAL SPRAYERS
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-106">
            <Link to="/" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-107">
              Home
            </Link>
            <a href="/#products" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-108">
              Products
            </a>
            <a href="/#features" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-109">
              Features
            </a>
          </nav>

          {/* Cart & Mobile Menu */}
          <div className="flex items-center gap-4" data-id="element-110">
            <Link to="/cart" className="relative p-2 rounded-xl hover:bg-gray-900 transition-colors group" data-id="element-111">
              <ShoppingCart className="w-6 h-6 text-gray-300 group-hover:text-white transition-colors" data-id="element-112" />
              {itemCount > 0 && <span className="absolute -top-1 -right-1 bg-gradient-to-r from-[#FF6B35] to-[#FFA500] text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center animate-in zoom-in" data-id="element-113">
                  {itemCount}
                </span>}
            </Link>

            <button className="md:hidden text-gray-300 hover:text-white p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-114">
              {isMenuOpen ? <X size={24} data-id="element-115" /> : <Menu size={24} data-id="element-116" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-[#1a1a1a] border-t border-gray-900" data-id="element-117">
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-118">
            <Link to="/" className="text-white font-medium py-2 hover:text-[#FF6B35] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-119">
              Home
            </Link>
            <a href="/#products" className="text-white font-medium py-2 hover:text-[#FF6B35] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-120">
              Products
            </a>
            <a href="/#features" className="text-white font-medium py-2 hover:text-[#FF6B35] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-121">
              Features
            </a>
          </nav>
        </div>}
    </header>;
}